import * as swcHelpers from '@swc/helpers';
import { toDrafts } from '../../server/to-drafts.js';
import { toOrderLineItem } from '../line-item/order-line-item.js';
import { toAddress, toOrderDetailPrice } from './orders.js';
import { isEveryLineItemReorderable } from '../../../utils/is-line-item-reorderable.js';
import { getPaymentMethodLabel } from '../utils/get-payment-method-label.js';
import { getPaymentStatusLabel } from '../utils/get-payment-status-label.js';
import { getShipmentStatusLabel } from '../utils/get-shipment-status-label.js';

const toOrderDetails = (order, intl, options = {})=>{
    if (!order) {
        return undefined;
    }
    var ref, _receiptUrl, _shipmentTrackingURL, _paymentStatus;
    return swcHelpers.objectSpread({
        billingAddress: toAddress(order.billingAddress),
        shippingInfo: order.shippingInfo.deliveryMethodName,
        drafts: toDrafts(order.lineItems),
        isReorderAvailable: isEveryLineItemReorderable(order.lineItems),
        lineItems: order.lineItems.map((lineItem)=>toOrderLineItem(lineItem, intl, options)
        ),
        orderDate: new Date(order.orderDate),
        orderNumber: order.orderNumber,
        paymentMethod: getPaymentMethodLabel(order.paymentMethod, intl),
        paymentStatus: (ref = getPaymentStatusLabel(order.paymentStatus, intl)) !== null && ref !== void 0 ? ref : '',
        receiptUrl: (_receiptUrl = order.receiptUrl) !== null && _receiptUrl !== void 0 ? _receiptUrl : undefined,
        shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl),
        shipmentTrackingUrl: (_shipmentTrackingURL = order.shipmentTrackingURL) !== null && _shipmentTrackingURL !== void 0 ? _shipmentTrackingURL : undefined,
        shippingAddress: toAddress(order.shippingAddress),
        rawPaymentStatus: (_paymentStatus = order.paymentStatus) !== null && _paymentStatus !== void 0 ? _paymentStatus : ''
    }, toOrderDetailPrice(order.price));
};

export { toOrderDetails };
//# sourceMappingURL=order-details.js.map
